/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface IUnauthorizedResponse {
  /** @example 401 */
  statusCode: number
  /** @example "Unauthorized" */
  error: string
}

export interface IForbiddenResponse {
  /** @example 403 */
  statusCode: number
  /** @example "Forbidden" */
  error: string
}

export interface IInvestmentOfferItem {
  amount: number
  bonus: number
  bonusAdditionalSpecial: number
  bonusPercent: number
  bonusWelcome: number
  bonusWelcomePercent: number
  bonusFixed: number
  bonusFixedPercent: number
  bonusPrereservationPercent: number
  bonusPrereservation: number
  bonusLastminutePercent: number
  bonusLastminute: number
  reservationCouponValue: number
  totalYield: number
  totalYieldPerAnnum: number
  revenue: number
  total: number
  totalWithCouponValue: number
  revenueFeeApplied: number
}

export interface IOrderGetOfferDataOkResponse {
  /** Optional success message */
  message?: string
  offerData: IInvestmentOfferItem
  /** Available future revenue (cents) */
  availableFutureRevenueFixed: number
}

export interface INotFoundResponse {
  /** @example 404 */
  statusCode: number
  /** @example "Not Found" */
  error: string
}

export interface IOrderPrincipalFixed {
  /** Cash part in cents */
  disponibleFunds: number
  /** Booster part in cents */
  futureRevenue: number
}

export interface IOrderAgreementPreviewRequest {
  projectId: string
  walletId: string
  principalFixed: IOrderPrincipalFixed
}

export interface IAgreementPreviewItem {
  header: string
  title: string
  content: string
  content2: string
  sign: string
}

export interface IOrderAgreementPreviewOkResponse {
  /** Optional success message */
  message?: string
  agreement: IAgreementPreviewItem
}

export interface IBadRequestResponse {
  /** @example 400 */
  statusCode: number
  /** @example "Bad Request" */
  error: string
}

export interface IOrderCreateVerifyRequest {
  projectId: string
  walletId: string
  principalFixed: IOrderPrincipalFixed
}

export interface IOrderCreateVerifyOkResponse {
  /** Optional success message */
  message?: string
  /** @format date-time */
  expiresAt: string
}

export interface IOrderCreateSignRequest {
  projectId: string
  walletId: string
  principalFixed: IOrderPrincipalFixed
  /** 5-char alphanumeric 2FA code from verify step */
  code: string
}

export interface IOrderCreateSignOkResponse {
  /** Optional success message */
  message?: string
  investmentId: string
  /** True if this investment qualifies the user for fee-immunity (campaign active + first qualifying investment + value >= MIN_AMOUNT) */
  isUserEligibleForFeeImmunity: boolean
}

export interface IOrderWithdrawOkResponse {
  /** Optional success message */
  message?: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(
      (key) => 'undefined' !== typeof query[key]
    )
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        )
        return formData
      }, new FormData())
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const responseToParse = responseFormat ? response.clone() : response
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title IIS Investment API
 * @version 1.0
 * @contact
 *
 * API for Investment orders
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  investment = {
    /**
     * No description
     *
     * @tags Create Order
     * @name OrderControllerGetOfferData
     * @summary Compute investment offer projection for a given order amount (order form calculator)
     * @request GET:/investment/order/{businessId}/{stageNumber}/offer
     * @secure
     */
    orderControllerGetOfferData: (
      businessId: number,
      stageNumber: number,
      query: {
        orderAmount: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        IOrderGetOfferDataOkResponse,
        IUnauthorizedResponse | IForbiddenResponse | INotFoundResponse
      >({
        path: `/investment/order/${businessId}/${stageNumber}/offer`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Create Order
     * @name OrderControllerGetAgreementPreview
     * @summary Render order agreement preview HTML (SK + user lang) without saving anything
     * @request POST:/investment/order/agreement-preview
     * @secure
     */
    orderControllerGetAgreementPreview: (
      data: IOrderAgreementPreviewRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOrderAgreementPreviewOkResponse,
        | IBadRequestResponse
        | IUnauthorizedResponse
        | IForbiddenResponse
        | INotFoundResponse
      >({
        path: `/investment/order/agreement-preview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Create Order
     * @name OrderControllerCreateStartVerification
     * @summary Start 2FA verification for an investment order (DEV: logs code to console)
     * @request POST:/investment/order/create/start-verification
     * @secure
     */
    orderControllerCreateStartVerification: (
      data: IOrderCreateVerifyRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOrderCreateVerifyOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/investment/order/create/start-verification`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Create Order
     * @name OrderControllerSignOrder
     * @summary Validate 2FA code and create investment + RESERVATION transaction
     * @request POST:/investment/order/create/sign-order
     * @secure
     */
    orderControllerSignOrder: (
      data: IOrderCreateSignRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IOrderCreateSignOkResponse,
        | IBadRequestResponse
        | IUnauthorizedResponse
        | IForbiddenResponse
        | INotFoundResponse
      >({
        path: `/investment/order/create/sign-order`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Create Order
     * @name OrderControllerWithdrawOrder
     * @summary User-initiated withdrawal of RESERVED investment within 4-day window
     * @request POST:/investment/order/{investmentId}/withdraw
     * @secure
     */
    orderControllerWithdrawOrder: (
      investmentId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        IOrderWithdrawOkResponse,
        IUnauthorizedResponse | IForbiddenResponse | INotFoundResponse
      >({
        path: `/investment/order/${investmentId}/withdraw`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Create Order
     * @name OrderControllerDownloadAgreement
     * @request GET:/investment/order/{investmentId}/agreement.pdf
     * @secure
     */
    orderControllerDownloadAgreement: (
      investmentId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, IUnauthorizedResponse | IForbiddenResponse>({
        path: `/investment/order/${investmentId}/agreement.pdf`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
}
